export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s seçilmemiş';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s boş olamaz';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s zorunlu bir alandır';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s doğru doldurulmamış';
                break;

            case 'opt-in':
                translation = 'Devam etmek için lütfen kutuyu işaretleyin';
                break;

            default:
                translation = 'Bu alan doğru şekilde doldurulmamış';
                break;
        }

        return translation;
    }
}
